var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M11.169 1.014a1 1 0 0 1 .823.862L12.882 9H19a1 1 0 0 1 .894 1.447l-6 12a1 1 0 0 1-1.886-.323L11.118 15H5a1 1 0 0 1-.894-1.447l6-12a1 1 0 0 1 1.063-.539z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }